import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const carouselImages = [
  'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/m30kxue7_IMG_2335.jpg',
  'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/mscnzr9z_IMG_0520.jpeg',
  'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/h6bamaz9_b84de372-27f9-4c25-be89-0b189d47064e%20%282%29.JPG',
];

export const Hero = () => {
  const { t } = useLanguage();
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrentImage((p) => (p + 1) % carouselImages.length), 5000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- carouselImages is a static module-level constant, safe to omit
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden" data-testid="hero-section">
      <AnimatePresence mode="wait">
        <motion.img key={currentImage} src={carouselImages[currentImage]} alt="Adrienne and Thomas"
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.8 }} />
      </AnimatePresence>
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B3D]/50 via-[#1A2B3D]/10 to-[#1A2B3D]/80" />

      <button onClick={() => setCurrentImage((p) => (p - 1 + carouselImages.length) % carouselImages.length)}
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors z-10"
        data-testid="hero-prev">
        <ChevronLeft className="w-5 h-5 text-white" /></button>
      <button onClick={() => setCurrentImage((p) => (p + 1) % carouselImages.length)}
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-colors z-10"
        data-testid="hero-next">
        <ChevronRight className="w-5 h-5 text-white" /></button>

      <div className="absolute bottom-8 inset-x-0 flex items-center justify-center gap-2 z-10">
        {carouselImages.map((img, i) => (
          <button key={img} onClick={() => setCurrentImage(i)}
            className={`w-2 h-2 rounded-full transition-colors ${i === currentImage ? 'bg-white' : 'bg-white/40'}`} />
        ))}
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }}
          className="font-serif text-5xl sm:text-7xl md:text-8xl font-light text-white mb-6" data-testid="couple-names">
          Adrienne & Thomas
        </motion.h1>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.5 }}
          className="text-white text-xs uppercase tracking-[0.3em] font-medium mb-6">
          {t('weddingCelebration')}
        </motion.p>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.7 }}
          className="font-serif text-xl sm:text-2xl text-white mb-2">October 10th, 2026</motion.p>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.8 }}
          className="font-serif text-lg sm:text-xl text-white/80">Annapolis, Maryland</motion.p>
        <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 1 }}
          onClick={() => document.querySelector('#schedule')?.scrollIntoView({ behavior: 'smooth' })}
          className="mt-10 text-white text-sm tracking-wide hover:text-[#C9A96E] transition-colors underline underline-offset-4"
          data-testid="scroll-to-schedule">
          {t('scrollToSchedule')}
        </motion.button>
      </div>
    </section>
  );
};
